import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import app from "../components/app/reducer";
import auth from "../components/Auth/reducer";
import user from "../components/User/reducer";
import invites from "../components/Invites/reducer";
import approvals from "../components/User/ApprovalsTable/reducer";
import settings from "../components/settings/reducer";
import security from "../components/security/reducer";

export default (history) => {
  const rootReducer = combineReducers({
    app,
    auth,
    user,
    approvals,
    invites,
    settings,
    security,
    router: connectRouter(history),
  });

  return (state = {}, action) => {
    if (!action) return state;

    // use the regular reducer
    return rootReducer(state, action);
  };
};
